// extracted by mini-css-extract-plugin
export var circular = "styles-module--circular--3cdfd";
export var image = "styles-module--image--65780";